(function(){
  function init(){
    var bar=document.getElementById('qz-mobile-purchase');
    if(!bar || bar.dataset.ready) return;
    bar.dataset.ready='true';
    var data=JSON.parse(document.getElementById('qz-mobile-purchase-data').textContent);
    var action=document.getElementById('qz-mobile-purchase-action');
    var option=document.getElementById('qz-mobile-purchase-option');
    var price=document.getElementById('qz-mobile-purchase-price');
    var change=document.getElementById('qz-mobile-purchase-change');
    var mobile=window.matchMedia('(min-width:0px)');
    var chosen=!data.multiple || new URLSearchParams(location.search).has('variant');
    var busy=false,queued=false,current=null;
    var originalPad=getComputedStyle(document.body).paddingBottom;
    document.body.style.setProperty('--qz-purchase-original-pad',originalPad);
    function mainButton(){return document.querySelector('#main-content .product__section-details .product__form-buttons .AddtoCart');}
    function details(){var b=mainButton();return b && b.closest('.product__section-details');}
    function selectedVariant(){
      var d=details();if(!d)return null;
      var controls=d.querySelectorAll('.product__variants-swatches input:checked,.product__variants-swatches select');
      var opts=Array.from(controls).map(function(e){return e.value;});
      if(opts.length){return data.variants.find(function(v){return v.options.every(function(o,i){return o===opts[i];});})||null;}
      var form=mainButton().form;
      var input=form && form.querySelector('[name="id"]');
      return data.variants.find(function(v){return String(v.id)===String(input && input.value);}) || data.variants.find(function(v){return v.id===data.selected;});
    }
    function choose(){
      var d=details();if(!d)return;
      var target=d.querySelector('.product__variants-swatches')||d;
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
      var label=target.querySelector('label[tabindex],select');
      if(label)label.focus({preventScroll:true});
    }
    function update(){
      queued=false;
      var b=mainButton(),d=details();
      if(!b||!d){bar.hidden=true;return;}
      current=selectedVariant();
      var title=d.querySelector('h1')||document.querySelector('#main-content h1');
      var nav=document.querySelector('#ad-mobile-menu-bar .mobile-menu-tabbar');
      var nr=nav&&nav.getBoundingClientRect();
      var navHeight=nr && getComputedStyle(nav).display!=='none' && nr.height>0 && nr.top<innerHeight && nr.bottom>innerHeight-5 ? Math.max(0,innerHeight-nr.top):0;
      var safe=navHeight ? '0px':'env(safe-area-inset-bottom,0px)';
      bar.style.setProperty('--qz-purchase-nav',navHeight+'px');
      bar.style.setProperty('--qz-purchase-safe',safe);
      document.body.classList.toggle('qz-purchase-ready',mobile.matches);
      var br=b.getBoundingClientRect();
      var visibleMain=br.height>0 && br.top<innerHeight-navHeight-85 && br.bottom>90;
      var overlay=document.querySelector('.slideout--active,.pswp--open,[role="dialog"][aria-modal="true"]');
      var focused=document.activeElement;
      var keyboard=focused && focused.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="submit"]):not([type="hidden"]),textarea,[contenteditable="true"]');
      var zoom=window.visualViewport && window.visualViewport.scale>1.1;
      var shown=mobile.matches && title && title.getBoundingClientRect().top<innerHeight-navHeight-85 && !visibleMain && !overlay && !keyboard && !zoom;
      bar.hidden=!shown;
      document.body.classList.toggle('qz-purchase-visible',!!shown);
      var label=data.title + (current && data.multiple ? ' — '+current.title : '');
      if(option.textContent!==label)option.textContent=label;
      if(price.textContent!==(current ? current.price:''))price.textContent=current ? current.price:'';
      change.hidden=!data.multiple || !chosen;
      var sold=current && !current.available;
      var text=busy?'Adding...':(!chosen||!current?'Choose options':sold?'Sold out':'Add to cart');
      if(action.textContent!==text)action.textContent=text;
      action.disabled=busy || (chosen && !!sold) || (chosen && current && b.disabled);
      if(shown)document.body.style.setProperty('--qz-purchase-reserve',(bar.getBoundingClientRect().height+navHeight+16)+'px');
    }
    function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
    document.addEventListener('change',function(e){var d=details();if(d&&d.contains(e.target)){if(e.target.closest('.product__variants-swatches'))chosen=true;schedule();setTimeout(schedule,150);}},true);
    document.addEventListener('focusin',schedule);
    document.addEventListener('focusout',schedule);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    if(window.visualViewport)window.visualViewport.addEventListener('resize',schedule,{passive:true});
    mobile.addEventListener('change',schedule);
    new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class']});
    change.addEventListener('click',choose);
    action.addEventListener('click',function(){
      update();
      if(!chosen||!current){choose();return;}
      var b=mainButton();
      if(!b||b.disabled||!current.available||busy)return;
      var form=b.form,id=form && form.querySelector('[name="id"]');
      if(!id||String(id.value)!==String(current.id)){choose();return;}
      busy=true;update();b.click();
      setTimeout(function(){busy=false;schedule();},1800);
    });
    setInterval(function(){if(mobile.matches&&!document.hidden)schedule();},700);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
